import React from 'react';
import { Button } from '@sandtech-hub-monorepo/ui-kit';
import { ReactComponent as QuestionMarkIcon } from '../../assets/Icons/question-mark-icon.svg';
import { useNavigate } from 'react-router-dom';

export const SupportCard = ({
  answeBaseEnabled,
  supportPageLink,
}: {
  answeBaseEnabled?: boolean;
  supportPageLink: string;
}) => {
  const navigate = useNavigate();

  const title = answeBaseEnabled ? 'AnswerBase' : 'Support';
  const text = answeBaseEnabled
    ? 'Ask learning questions to our Technical Mentors, get answers, and engage with fellow learners on AnswerBase today!'
    : 'Get instant help on administrative issues from LEA, our AI assistant, or contact our support team.';

  return (
    <div className="sm:min-w-[420px] flex-1 bg-primary/10 p-8 border rounded-sm border-primary/20 flex gap-6 items-start">
      <div className="p-6 bg-primary/20 rounded-full text-secondary sm:block hidden">
        <QuestionMarkIcon />
      </div>
      <div className="flex flex-col gap-2 items-start">
        <h3 className="text-secondary text-3xl font-semibold">{title}</h3>
        <div>{text}</div>
        <Button
          className="mt-1"
          onClick={() => {
            if (answeBaseEnabled) {
              window.location.replace('https://answers.alx-staging.com/');
            } else {
              navigate(supportPageLink);
            }
          }}
        >
          Continue
        </Button>
      </div>
    </div>
  );
};
